import React from 'react';
import { PinInput as ChakraPinInput, PinInputProps as ChakraPinInputProps } from '@chakra-ui/react';

export function PinInput(props: ChakraPinInputProps) {
  return <ChakraPinInput {...props} />;
}
